export default "__VITE_ASSET__92e240f5__"